<template>
      <section aria-label="Footer Payback">
            <iframe width="100%" overlay-width="1280" scrolling="no" id="footer-iframe" :src="`${footerFrameUrl}?frameId=pb-iframe0&amp;parentUrl=${feUrl}`" style="width: 1px; min-width: 100%; height: 384px; min-height: 384px; max-height: 384px; border: 0" title="footer payback"></iframe>
      </section>
</template>

<script>
      export default {
            name: "FooterPb",
            props: {
                  msg: String
            },
            components: {},
            data() {
                  return {
                        feUrl: import.meta.env.VITE_FE,
                        footerFrameUrl: import.meta.env.VITE_FOOTER_FRAME || "https://www.payback.at/bargeld-footer"
                  };
            }
      };
</script>
